import { Modal } from '@/components/ui/modal';
import { Text } from '@/components/ui/text';
import { getProfileShareUrl } from '@/utils/share-urls';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Pressable, useWindowDimensions, View } from 'react-native';
import QRCode from 'react-native-qrcode-svg';

import { computeQrSize } from '../utils/qr-size';

interface QrCodeModalProps {
  visible: boolean;
  onClose: () => void;
  username: string;
  displayName: string;
}

export function QrCodeModal({ visible, onClose, username, displayName }: QrCodeModalProps) {
  const profileUrl = getProfileShareUrl(username);
  const { width } = useWindowDimensions();
  const qrSize = computeQrSize(width);

  return (
    <Modal visible={visible} onClose={onClose}>
      <View className="bg-surface" style={{ borderRadius: 12 }}>
        {/* Header */}
        <View className="flex-row items-center justify-between px-4 py-3 border-b border-border">
          <Text className="text-lg font-semibold text-foreground">Share Profile</Text>
          <Pressable
            onPress={onClose}
            hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
            accessibilityRole="button"
            accessibilityLabel="Close"
          >
            <Ionicons name="close" size={24} className="text-muted-foreground" />
          </Pressable>
        </View>

        {/* Body */}
        <View className="items-center py-6 px-4">
          <Text className="text-lg font-semibold text-foreground mb-1">
            {displayName}
          </Text>
          <Text className="text-sm text-muted-foreground mb-5">
            @{username}
          </Text>
          <View
            style={{ borderRadius: 12 }}
            testID="qr-code-container"
          >
            <QRCode
              value={profileUrl}
              size={qrSize}
              backgroundColor="transparent"
              enableLinearGradient={true}
              linearGradient={['#67CE00', '#35FA84']}
              ecl="H"
            />
          </View>
          <Text className="text-xs text-muted-foreground mt-4 text-center">
            Scan this code to view profile
          </Text>
        </View>
      </View>
    </Modal>
  );
}
